import { render, staticRenderFns } from "./TablaGoleadores.vue?vue&type=template&id=1bf85fc6&scoped=true"
import script from "./TablaGoleadores.vue?vue&type=script&lang=ts"
export * from "./TablaGoleadores.vue?vue&type=script&lang=ts"
import style0 from "./TablaGoleadores.vue?vue&type=style&index=0&id=1bf85fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf85fc6",
  null
  
)

export default component.exports